export default __webpack_public_path__ + "static/media/painting.f6bf60bf.jpg";